RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const Message = views.Message = Marionette.ItemView.extend({
        getTemplate: function () {
            const me = this;
            if (me.model.get('orientation') === 'vertical') {
                return '#verticalMessageTemplate';
            }

            return '#messageTemplate';
        },
        templateHelpers: function () {
            const me = this;
            return _.defaults(me.model.toJSON(), {
                action: null,
                image: null,
                muted: false,
                leading: false
            });
        }
    });

    /**
     * Converts details to a suitable model.
     * @param details
     */
    Message.detailsToModel = function (details, model) {
        const me = this;
        return new Backbone.Model(_.resultingObject(me, details, model));
    };

    /**
     * Builds a message view.
     * @param type
     * @param model
     * @param options
     */
    Message.build = function (type, model, options) {

        const details = RivalIQ.configuration.messageDetails[type];

        const attributes = {
            model: Message.detailsToModel(details, model)
        };

        return new Message(_.extend(attributes, options));
    };

    /**
     * Creates a message class from type (for use as empty view, etc).
     * @param type
     * @param [model]
     */
    Message.createClassFromType = function (type, model) {

        const details = RivalIQ.configuration.messageDetails[type];

        const Cls = Message.extend({
            initialize: function () {

                const me = this;
                me.model = Message.detailsToModel(details, model);
            }
        });

        return Cls;
    };

});
